import React from 'react';
import { FaCheckCircle, FaCreditCard } from 'react-icons/fa';

/**
 * Payment method tile — radio + label so selection works on all devices/themes.
 */
export default function PaymentOptionCard({ option, isSelected, groupName, onSelect }) {
  const IconComponent = option.icon || FaCreditCard;
  const brandColor = option.color || '#1F4E8C';
  const inputId = `payment-method-${option.id}`;

  return (
    <div className="relative">
      <input
        type="radio"
        id={inputId}
        name={groupName}
        value={option.id}
        checked={isSelected}
        onChange={() => onSelect(option.id)}
        className="peer sr-only"
      />
      <label
        htmlFor={inputId}
        className="payment-option-card block w-full cursor-pointer select-none rounded-xl border-2 p-4 transition-all active:scale-[0.99] sm:p-5"
        style={
          isSelected
            ? {
                borderColor: brandColor,
                backgroundColor: `${brandColor}14`,
                boxShadow: `0 4px 14px ${brandColor}33`,
              }
            : {
                borderColor: '#e5e7eb',
                backgroundColor: '#ffffff',
              }
        }
      >
        {option.popular && !isSelected && (
          <span className="absolute right-3 top-3 rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-amber-800">
            Popular
          </span>
        )}

        {isSelected && (
          <span
            className="absolute right-3 top-3 flex h-6 w-6 items-center justify-center rounded-full text-white"
            style={{ backgroundColor: brandColor }}
          >
            <FaCheckCircle className="text-xs" />
          </span>
        )}

        <span className="flex items-center gap-3 sm:gap-4">
          <span
            className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl shadow-sm sm:h-14 sm:w-14"
            style={{
              background: `linear-gradient(135deg, ${brandColor}, ${brandColor}cc)`,
            }}
          >
            <IconComponent className="text-xl text-white sm:text-2xl" />
          </span>

          <span className="min-w-0 flex-1 pr-8">
            <span className="block text-sm font-semibold text-gray-900 sm:text-base">
              {option.name}
            </span>
            <span className="mt-0.5 block text-xs text-gray-600 sm:text-sm">
              {option.description}
            </span>
          </span>
        </span>
      </label>
    </div>
  );
}
